import { RawCriterionWeight } from "@Criteria/Model";
import { ICriteriaCommand } from "@Criteria/cqrs";

export class CreateWeightsSetCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Weights.Commands.CreateWeightsSetCommandV1, TCh.Domain.Criteria';

	WorkspaceId: number;
	Id: string;
	WeightsSetId: number;
	Name: string;
	Weights: RawCriterionWeight[]

	constructor(workspaceId: number, chId: number, name: string, weights: RawCriterionWeight[])
	{
		this.WorkspaceId = workspaceId;
		this.Id = chId.toString();
		this.WeightsSetId = 0;
		
		this.Name = name;
		this.Weights = weights;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Weights.Commands.CreateWeightsSetCommandV1, TCh.Domain.Criteria'
	}
}

export class UpdateWeightsSetCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Weights.Commands.UpdateWeightsSetCommandV1, TCh.Domain.Criteria';

	WorkspaceId: number;
	Id: string;
	WeightsSetId: number;

	Name: string;
	Weights: RawCriterionWeight[];

	constructor(workspaceId: number, chId: number, weightsSetId: number, name: string, weights: RawCriterionWeight[])
	{
		this.WorkspaceId = workspaceId;
		this.Id = chId.toString();
		this.WeightsSetId = weightsSetId;
		
		this.Name = name;
		this.Weights = weights;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Weights.Commands.UpdateWeightsSetCommandV1, TCh.Domain.Criteria'
	}
}

export class DeleteWeightsSetCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Weights.Commands.DeleteWeightsSetCommandV1, TCh.Domain.Criteria';

	WorkspaceId: number;
	Id: string;
	WeightsSetId: number;

	constructor(workspaceId: number, chId: number, cwsId: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = chId.toString();
		this.WeightsSetId = cwsId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Weights.Commands.DeleteWeightsSetCommandV1, TCh.Domain.Criteria'
	}
}


export class ExportWeightsToXlsFromWeightsSetCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Weights.Commands.ExportWeightsToXlsFromWeightsSetCommandV1, TCh.Domain.Criteria';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	WeightsSetId: number;

	constructor(workspaceId: number, projectId: number, chId: number, cwsId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = chId.toString();
		this.WeightsSetId = cwsId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Weights.Commands.ExportWeightsToXlsFromWeightsSetCommandV1, TCh.Domain.Criteria'
	}
}

export class ExportWeightsToXlsFromPanelistVotesCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Weights.Commands.ExportWeightsToXlsFromPanelistVotesCommandV1, TCh.Domain.Criteria';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	EvalModelId: number;
	ProjectUserId: number;

	constructor(workspaceId: number, projectId: number, chId: number, evalModelId: number, projectUserId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = chId.toString();
		this.EvalModelId = evalModelId;
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Weights.Commands.ExportWeightsToXlsFromPanelistVotesCommandV1, TCh.Domain.Criteria'
	}
}

export class ExportWeightsToXlsFromSurveyVotesCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Weights.Commands.ExportWeightsToXlsFromSurveyVotesCommandV1, TCh.Domain.Criteria';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	EvalModelId: number;
	SurveyId: number;

	constructor(workspaceId: number, projectId: number, chId: number, evalModelId: number, surveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = chId.toString();
		this.EvalModelId = evalModelId;
		this.SurveyId = surveyId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Weights.Commands.ExportWeightsToXlsFromSurveyVotesCommandV1, TCh.Domain.Criteria'
	}
}

export class ExportAllWeightsToXlsCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Weights.Commands.ExportAllWeightsToXlsCommandV1, TCh.Domain.Criteria';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	EvalModelId: number;

	constructor(workspaceId: number, projectId: number, chId: number, evalModelId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = chId.toString();
		this.EvalModelId = evalModelId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Weights.Commands.ExportAllWeightsToXlsCommandV1, TCh.Domain.Criteria'
	}
}


